module.exports = __webpack_public_path__ + "img/logo.7be0bd3e.jpg";